import { Injectable } from '@angular/core';
import { CookieStore } from 'cookie-store';

/** A factory to cache data values. */
@Injectable()
export class StoreService {

  private _store: Storage;

  constructor() {
    if (typeof (Storage) == undefined) {
      this._store = new CookieStore() as Storage;
    }
    else {
      this._store = sessionStorage as Storage;
    }
  }

  /**
   * Clears the cache array.
   * @returns {void}
   */
  public clear(): void {
    this._store.clear();
  }

  /**
   * Gets a stored item by key name and returns a string.
   * @param   {string}  key       - The unique key name.
   * @throws  {ArgumentNullError} - Will throw an error if the `key` argument is null or undefined.
   * @returns {(string | null)}   - The stored item. Returns null if nothing is found.
   */
  public getItem(key: string): string | null {
    if (key == undefined) {
     // throw new ArgumentNullError('key');
    }

    return this._store.getItem(key);
  }

  /**
   * Gets a stored object instance by the key name.  Returns null if it doesn't exist.
   * @param   {string}  key       - The unique key name.
   * @throws  {ArgumentNullError} - Will throw an error if the `key` argument is null or undefined.
   * @returns {object}            - The stored object.
   */
  public getObject(key: string): any {
    let o = this.getItem(key);
    if (o == undefined) { return undefined; }

    return JSON.parse(o);
  }

  /**
   * Removes an item by the key name.
   * @param {string}  key         - The unique key name.
   * @throws  {ArgumentNullError} - Will throw an error if the `key` argument is null or undefined.
   * @returns {void}
   */
  public removeItem(key: string) {
    if (key == undefined) {
      //throw new ArgumentNullError('key');
    }

    this._store.removeItem(key);
  }

  /**
   * Sets a string item by key name.
   * @param   {string}  key       - The unique key name.
   * @param   {string}  value     - The string value to be stored.
   * @throws  {ArgumentNullError} - Will throw an error if the `key` argument is null or undefined.
   * @returns {void}
   */
  public setItem(key: string, value: string): void {
    if (key == undefined) {
      //throw new ArgumentNullError('key');
    }

    this._store.setItem(key, value);
  }

  /**
   * Sets an object instance by key name.
   * @param {string}  key         - The unique key name.
   * @param {object}  value       - The string value to be stored.
   * @throws  {ArgumentNullError} - Will throw an error if the `key` argument is null or undefined.
   * @returns {void}
   */
  public setObject(key: string, value: any): void {
    this.setItem(key, JSON.stringify(value));
  }
}
